export default __webpack_public_path__ + "static/media/applications_face_statistics.05004367.png";